<template>
  <form action="#"
        v-if="formData.hasOwnProperty('button')"
        :id="'form-' + formId"
        @submit.prevent="processForm">
    <fieldset>
      <legend class="h3 font-weight-bold font-color-secondary">{{formData.description || formData.title}}</legend>

      <div v-if="!this.$store.state.isPhoneNotEmptyAndCorrect || !formIsValid"
           ref="formError"
           class="form__confirmation form__confirmation--error">
        <p v-html="formInvalidMessage"></p>
      </div>

      <div v-if="isCaptchaError"
           ref="formError"
           class="form__confirmation form__confirmation--error">
        <p v-html="captchaErrorMessage"></p>
      </div>

      <div class="row">
        <template v-for="(field, fieldKey) in formData.fields">
          <v-field-html v-if="field.type === 'html'"
                        :form-id="formId"
                        :field="field"
                        :field-key="fieldKey">
          </v-field-html>

          <v-field-textarea v-else-if="field.type === 'textarea' && conditionalDisplay(field)"
                            :form-id="formId"
                            :field="field"
                            :is-error="validationMessages[field.id]"
                            :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-textarea>

          <v-field-select v-else-if="field.type === 'select' && conditionalDisplay(field)"
                          :form-id="formId"
                          :field="field"
                          :lexicon="lexicon"
                          :is-error="validationMessages[field.id]"
                          :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-select>

          <v-field-date v-else-if="field.type === 'date' && conditionalDisplay(field)"
                        :form-id="formId"
                        :field="field"
                        :is-error="validationMessages[field.id]"
                        :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-date>

          <v-field-time v-else-if="field.type === 'time' && conditionalDisplay(field)"
                        :form-id="formId"
                        :field="field"
                        :is-error="validationMessages[field.id]"
                        :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-time>

          <v-field-radio v-else-if="field.type === 'radio' && conditionalDisplay(field)"
                         :form-id="formId"
                         :field="field"
                         :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-radio>

          <v-field-checkbox v-else-if="field.type === 'checkbox' || field.type === 'consent'"
                          :form-id="formId"
                         :field="field"
                         :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id]">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-checkbox>

          <v-field-text v-else-if="field.type === 'text' && conditionalDisplay(field)"
                        :form-id="formId"
                        :field="field"
                        :vehicle-id="vehicleId"
                        :field-key="fieldKey"
                        :is-error="validationMessages[field.id]">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-text>

          <v-field-number v-else-if="field.type === 'number' && conditionalDisplay(field)"
                        :form-id="formId"
                        :field="field"
                        :field-key="fieldKey"
                        :is-error="validationMessages[field.id]">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-number>

          <v-field-email v-else-if="field.type === 'email' && conditionalDisplay(field)"
                         :form-id="formId"
                         :field="field"
                         :field-key="fieldKey"
                         :is-error="validationMessages[field.id]">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-email>

          <v-field-phone v-else-if="field.type === 'phone' && conditionalDisplay(field)"
                         :form-id="formId"
                         :field="field"
                         :field-key="fieldKey">

            <template #description
                      v-if="field.description">
              <div class="field-group__description">
                <span>{{field.description}}</span>
              </div>
            </template>

            <template #error
                      v-if="validationMessages[field.id] && $store.state.user_form_data['input_' + field.id].length === 0">
              <div class="field-group__error">
                <span>{{validationMessages[field.id]}}</span>
              </div>
            </template>
          </v-field-phone>
        </template>

        <div class="field-wrapper field-wrapper--large field-wrapper--submit">
          <button class="action action--button"
                  :disabled="formSendSuccessful"
                  type="submit">
            <span class="action__text">{{formData.button.text}}</span>
          </button>
        </div>

<!--        <pre>
          {{ this.$store.state.user_form_data}}
        </pre>-->

<!--        <pre>
          {{ this.$store.state.user_form_data_with_label}}
        </pre>

        <pre>{{this.$store.state.models}}</pre>-->

        <div v-if="formSubmittedMessage.length && formIsValid"
             class="form__confirmation form__confirmation--success"
             ref="formConfirmationSuccess"
             v-html="formSubmittedMessage"></div>
      </div>
    </fieldset>
  </form>
</template>

<script>
import store from '../store';
import Vue from 'vue'
import {getFormData, getLexicon, submitFormEntry, submitCaptcha} from '../rest-service/rest-service';
import AsyncComputed from 'vue-async-computed'
import {scrollToTarget} from '../utils/scrollToTarget';
import {isInViewport} from '../utils/isInViewport';
import VFieldEmail from './VFieldEmail.vue';
import VFieldHtml from './VFieldHtml.vue';
import VFieldPhone from './VFieldPhone.vue';
import VFieldRadio from './VFieldRadio.vue';
import VFieldCheckbox from './VFieldCheckbox.vue';
import VFieldText from './VFieldText.vue';
import VFieldTextarea from './VFieldTextarea.vue';
import VFieldSelect from './VFieldSelect.vue';
import VFieldNumber from './VFieldNumber.vue';
import VFieldDate from './VFieldDate.vue';
import VFieldTime from './VFieldTime.vue';
import { load } from 'recaptcha-v3'
Vue.use(AsyncComputed)
export default {
  store,
  name: "VForm",
  components: {
    VFieldNumber,
    VFieldEmail,
    VFieldHtml,
    VFieldPhone,
    VFieldRadio,
    VFieldCheckbox,
    VFieldText,
    VFieldTextarea,
    VFieldSelect,
    VFieldDate,
    VFieldTime
  },
  data () {
    return {
      formData: {},
      formIsValid: true,
      formSendSuccessful: false,
      formSubmittedMessage: '',
      formInvalidMessage: 'Formular enthält Fehler! Bitte beheben Sie die Fehler und versuchen Sie es erneut!',
      validationMessages: {},
      recaptcha: {},
      isCaptchaError: false,
      captchaErrorMessage: '',
      lexicon: {},
      captchaSecret: '6LeF0PcaAAAAAAc7iLX-O41DMWn5Urg0wkpFBDT4'
    }
  },
  props: {
    formId: Number,
    vehicleId: Number
  },

  mounted() {

    load('6LeF0PcaAAAAAB-Ad3iAO-_8Mi7e00ExZhE6w_em').then((recaptcha) => {
      this.recaptcha = recaptcha
    })
  },

  computed: {
    lang () {
      return document.documentElement.lang.split('-')[0]
    }
  },

  asyncComputed: {
    getContent () {
      const getForm = (formId = 1) => {
        return new Promise(resolve => {
          getFormData(formId, (response) => {
            resolve(response.data)
          })
        })
      }

      const getLexiconPromise = () => {
        return new Promise(resolve => {
          getLexicon(this.lang,(response) => {
            resolve(response.data)
          })
        })
      }

      Promise.all([
          getForm(this.formId),
          getLexiconPromise(),
      ]).then(result => {
        //console.log(result)
        this.formData = result[0]
        this.$store.commit("UPDATE_LEXICON", result[1])
        this.lexicon = result[1];

        this.formInvalidMessage = this.lexicon.form_error_message
        this.captchaErrorMessage = this.lexicon.captcha_error
      });
    }
  },

  methods: {
    processForm () {
      document.body.style.cursor = 'wait'

      if (this.$store.state.isPhoneNotEmptyAndCorrect) {
        this.onSubmit();
      }
    },

    onResponseToSubmission (response) {
      document.body.style.cursor = 'default'

      //console.log('on response to submission ', response)

      if (response.status > 201) {
        this.onError(response);
      } else {
        this.onSuccessfulSubmission(response);
      }
    },

    onError (response) {
      console.log('error ', response);
      this.formIsValid = response.data.is_valid
      this.validationMessages = response.data.validation_messages;

      this.$nextTick( () => {
        const formError = this.$refs.formError
        if (!isInViewport(formError)) {
          scrollToTarget(formError)
        }
      })
    },

    onSubmit () {
      /*let data = this.$store.state.user_form_data;

      data.form_id = this.formId
      this.sendSubmission(data)*/

      this.recaptcha.execute('submit').then((token) => {
        submitCaptcha({
          secret: this.captchaSecret,
          response: token
        }, (result) => {

          if (result.data.success && result.data.score >= 0.8) {

            // data to send from global store
            let data = this.$store.state.user_form_data;

            data.form_id = this.formId
            this.sendSubmission(data)

          }
          else {
            console.log(result.data['error-codes'])
            this.isCaptchaError = true
          }
        })
      })
    },

    sendSubmission (data) {
      //console.log('send submission ', data);
      submitFormEntry(data, {}, this.onResponseToSubmission)
    },

    onSuccessfulSubmission(response) {
      //console.log('response ', response)
      this.formIsValid = true;
      this.formSendSuccessful = true;
      this.formSubmittedMessage = response.data.confirmation_message;

      this.$nextTick( () => {
        const messageSuccess = this.$refs.formConfirmationSuccess
        if (!isInViewport(messageSuccess)) {
          scrollToTarget(messageSuccess)
        }
      })
    },

    conditionalDisplay(field){

      let logic = field.conditionalLogic;

      if (!logic) {
        return true
      }

      if (logic.enabled && logic.logicType === 'all'){
        for (let rule of logic.rules) {
          console.log('test')

          if (rule.operator === 'is' && this.$store.state.user_form_data['input_'+rule.fieldId] != rule.value){
            return false;
          }
        }
        return true;
      } else if (logic.enabled && logic.logicType === 'any'){
        return logic.rules.some(rule => {
          return rule.operator === 'contains' && this.$store.state.user_form_data['input_'+rule.fieldId] === rule.value
        })
      }
      return true;
    }
  }
}
</script>
